import React from "react";
import languageJp from "./locale/language.json";
import "./App.css";

function NotFound() {
  return (
    <div className="nf-page wrapper" data-nosnippet>
      <header className="s-pagetype _t-r">
        <div className="h-inner">
          <div className="h-layout">
            <div className="h-right">
              <div className="logo-area">
                <div className="h-logo">
                  <a href="/" id="header__logo">
                    <img
                      className="header_logo_icon"
                      src={require("./images/HeaderLogos.svg")}
                      width="340"
                      height="96"
                      alt="マイガード"
                    />
                  </a>
                </div>
                <p className="logo-rename-note">
                  ※AIK orderはマイガードに名称変更しました
                </p>
              </div>
            </div>
          </div>
        </div>
      </header>

      <main>
        <div id="wrap_all">
          <article id="login" className="container-fluid mb_L">
            <div className="container">
              <div className="row login-wrap">
                {/* Same classes as customer NotFound: horizontal center + mt_L top position */}
                <div className="col-12 text-center mt_L mb_S">
                  <h3 className="invalid_title">
                    {languageJp.PAGE_NOT_FOUND_404_NOT_FOUND}
                  </h3>
                  <h3 className="invalid_title">
                    {languageJp.PAGE_NOT_FOUND_REQUESTED_PAGE_NOT_FOUND}
                  </h3>
                </div>
              </div>
            </div>
          </article>
          <div className="nf-breadcrumb-wrap container-fluid">
            <div className="container">
              <div id="breadcrumb__list" className="row">
                <div className="col-12">
                  <div className="d-flex flex-wrap">
                    <div className="breadcrumb__list-item">
                      <i className="fas fa-home pr-2"></i>
                      <a href="/">TOP</a>
                    </div>
                    <div className="breadcrumb__list-item">
                      {languageJp.PAGE_NOT_FOUND_NOT_FOUND}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <footer>
        <div className="f-inner">
          <div id="f_upper" className="f-upper">
            <a
              href="/"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              <span>
                <i className="fa-solid fa-angle-up"></i>PAGE TOP
              </span>
            </a>
          </div>
          <div className="f-lower">
            <div className="container-1100">
              <div className="f-l-link-list">
                <ul>
                  <li>
                    <a href="/customer/terms" target="_blank" rel="noopener noreferrer">
                      ご注意事項
                      <br className="in-sp" />
                      （プライバシーポリシー/利用規約）
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://aik-security.co.jp/contact1"
                    >
                      お問い合わせ
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://aik-security.co.jp"
                    >
                      運営会社
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://sites.google.com/aik-security.co.jp/faq"
                    >
                      よくある質問
                    </a>
                  </li>
                  <li>
                    <div className="f-l-tel-title">
                      お電話でのお問い合わせはこちら
                    </div>
                    <div className="f-l-tel-num">
                      <i className="fa-solid fa-phone"></i>050-1790-2411
                    </div>
                    <div className="f-l-tel-detail">平日 10:00〜17:00</div>
                  </li>
                </ul>
              </div>
              <div className="f-copy">
                <small>© AIK Co., Ltd.</small>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default NotFound;